import { File as ResidentFile } from '@/types/residents/bulletin';
import { IBulletinPhoto } from '@/types/admin/bulletins';
import { sanitizeFileURL } from '@/utils/residents/utils';

const DEFAULT_ALLOWED_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'heic'] as const;

export interface SanitizeOptions {
  allowedExtensions?: readonly string[];
}

export const sanitizeResidentFiles = (
  files: ResidentFile[] | undefined,
  options?: SanitizeOptions
): IBulletinPhoto[] => {
  if (!files || files.length === 0) return [];
  const allowed = (options?.allowedExtensions || DEFAULT_ALLOWED_EXTENSIONS).map((e) => e.toLowerCase());

  return files
    .map((f) => {
      const url = sanitizeFileURL(f.fileUrl);
      const ext = f.label?.split('.').pop()?.toLowerCase();
      if (!url || !ext || !allowed.includes(ext)) return null;
      return {
        id: f.id,
        fileUrl: url,
        photoUrl: url,
      } as IBulletinPhoto;
    })
    .filter((p): p is IBulletinPhoto => Boolean(p));
};


